export const ApplicationName = 'ImageCropper';

export const QueryParameterNames = {
    ReturnUrl: 'returnUrl',
    Message: 'message'
};

export const AuthActions = {
    Login: 'login',
    LoginCallback: 'login-callback',
    LogoutCallback: 'logout-callback',
    Logout: 'logout',
    Profile: 'profile'
};

const authPrefix = '/authentication';
export const ApplicationAuthPaths = {
    DefaultLoginRedirectPath: '/',
    ApiAuthorizationClientConfigurationUrl: `/_configuration/${ApplicationName}`,
    ApiAuthorizationPrefix: authPrefix,
    Login: `${authPrefix}/${AuthActions.Login}`,
    LoginCallback: `${authPrefix}/${AuthActions.LoginCallback}`,
    LogOut: `${authPrefix}/${AuthActions.Logout}`,
    LogOutCallback: `${authPrefix}/${AuthActions.LogoutCallback}`,
    Profile: `${authPrefix}/${AuthActions.Profile}`,
    IdentityManagePath: '/Identity/Account/Manage'
};
